/**
 * usePeekEscLayer — React binding for lib/peekEscStack (UOW-4G #3672).
 *
 * Register while `active` is true; the shared registry guarantees one ESC
 * closes exactly the top stacked layer, and base shells' own bubble-phase
 * ESC listeners never fire while any layer is registered. `close` is read
 * through a ref so hosts can pass a fresh closure every render without
 * re-registering (which would break last-registered-wins ordering).
 */
import { useEffect, useRef } from 'react'
import { registerPeekLayer } from '@/lib/peekEscStack'

export function usePeekEscLayer(active: boolean, close: () => void): void {
  const closeRef = useRef(close)
  closeRef.current = close
  useEffect(() => {
    if (!active) return
    return registerPeekLayer(() => closeRef.current())
  }, [active])
}
